import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

import { useTranslation } from 'react-i18next';

import cpt_foto from './foto_cpt.png';
import shpp from './liq_1.jpg';

function Home() {

    const { t } = useTranslation();

    const navigate = useNavigate(); // Create a navigate function
    const images = [
        cpt_foto, // Replace with your image URLs
        shpp,
    ];

    const descriptions = t('pages.home.imgdescr', { returnObjects: true });

    const [currentIndex, setCurrentIndex] = useState(0); // State to track the current image index

    return(

        <div className="main-wrapper">
            <div className="sez0">
                    <h1>{t('pages.home.t2')}</h1>
                  <p className="hero-subtitle">
                    {t('pages.home.dsch')}
                  </p>
             </div>

            <div className="tools-wrapperS1" id="id1">
                <div className="title-sez1">{t('pages.home.ta')}</div>
                <div className="sez1" >
                    <div className="bloc-cont">
                        <div className="ic1" onClick={() => navigate('/GeoData')} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.home.a1')}</h3>
                            </div>
                            <div className="ic1-block">
                                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
                                   </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                        <div className="ic1" onClick={() => navigate('/newuser')} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.home.a3')}</h3>
                            </div>
                            <div className="ic1-block">
                                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={() => navigate('/developing')} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.home.a8')}</h3>
                            </div>
                            <div className="ic1-block">
                                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                     </div>
                </div>
            </div>

            <div className="tools-wrapperS2" id="id2">
                <div className="title-sez2">{t('pages.home.tb')}</div>
                <div className="sez2" >
                    <div className="bloc-cont">
                         {/* 🔹 WEBGIS */}
                        <div className="ic1" onClick={() => {navigate('/digital_services');window.scrollTo(0, 0);}}  style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.home.a4')}</h3>
                            </div>
                            <div className="ic1-block">
                                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                   <path strokeLinecap="round" strokeLinejoin="round" d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.586 1.586 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25" />
                                   </svg>
                            </div>
                            <div className="ic1-block">
                               <ul className="desc">{t('pages.home.s1')}</ul>
                            </div>
                        </div>


                        {/* 🔹 SOftware SaaS */}
                        <div className="ic1" onClick={() => {navigate('/discoverves');window.scrollTo(0, 0);}} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.home.a6')}</h3>
                            </div>
                            <div className="ic1-block">
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25" />
                                       </svg>
                            </div>
                            <div className="ic1-block">
                                <ul className="desc">{t('pages.home.s3')}</ul>
                            </div>
                        </div>
                        {/* 🔹 ELABORAZIONE PROVE */}
                        <div className="ic1" onClick={() => {navigate('/elaboration_services');window.scrollTo(0, 0);}} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.home.a7')}</h3>
                            </div>
                            <div className="ic1-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                                <ul className="desc">{t('pages.home.s4')}</ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tools-wrapperS1" id="id3">
                <div className="title-sez1">{t('navbar.consulenza')}</div>
                <div className="sez1" >
                        <p className="subtitle-sez1">
                        {t('pages.home.dsch2')}
                        </p>
                        <div className="subtitle-sez1">
                        <ul className="text-im-list">
                        {/* Lista di paragrafi, evita i <br/> */}
                        {[t('pages.home.dsch3'),t('pages.home.dsch4'),t('pages.home.dsch5'),
                        t('pages.home.dsch6'),t('pages.home.dsch7'),t('pages.home.dsch8')].map((i) => (
                          <li key={i} className="text-im-paragraph">
                            {t(`${i}`)}
                          </li>
                        ))}
                        </ul>
                        </div>

                        <div className="bloc-cont">
                          {/* Primo blocco: Carousel + descrizione */}
                          <div className="ic2">
                            <div className="image-and-description">
                              <img
                                src={images[currentIndex]} // immagine corrente
                                alt={`Image ${currentIndex + 1}`}
                                className="carousel-image"
                              />

                              {/* Descrizione corrente */}
                              <p className="image-description">
                                {descriptions[currentIndex]}
                              </p>

                              {/* Puntini di navigazione */}
                              <div className="dots">
                                {images.map((_, idx) => (
                                  <span
                                    key={idx}
                                    className={`dot ${idx === currentIndex ? 'active' : ''}`}
                                    onClick={() => setCurrentIndex(idx)}
                                  ></span>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                </div>
             </div>
         </div>
         ); }

export default Home;
